// routes
import { PATH_MY_ACCOUNT } from './routes/paths';

export const GOOGLE_MAP_API = process.env.REACT_APP_GOOGLE_MAP_KEY;
export const IVU_STATE = process.env.REACT_APP_IVU_STATE;
export const IVU_MUNICIPAL = process.env.REACT_APP_IVU_MUNICIPAL;

// API
// ----------------------------------------------------------------------

export const HOST_API_KEY = process.env.REACT_APP_HOST_API_KEY || '';
export const PATH_AFTER_LOGIN = PATH_MY_ACCOUNT.account;

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  H_MOBILE: 64,
  H_MAIN_DESKTOP: 88,
  H_DASHBOARD_DESKTOP: 92,
  H_DASHBOARD_DESKTOP_OFFSET: 92 - 32,
};

export const NAV = {
  W_BASE: 260,
  W_DASHBOARD: 280,
  W_DASHBOARD_MINI: 88,
  //
  H_DASHBOARD_ITEM: 48,
  H_DASHBOARD_ITEM_SUB: 36,
  //
  H_DASHBOARD_ITEM_HORIZONTAL: 32,
};

export const ICON = {
  NAV_ITEM: 24,
  NAV_ITEM_HORIZONTAL: 22,
  NAV_ITEM_MINI: 22,
};